<template>
    <div>
        <v-hover #default="{ hover }">
            <v-avatar
                size="124"
                color="primary lighten-3"
                class="mx-12 mb-6"
            >
                <v-img
                    v-if="avatar"
                    :src="avatar"
                />
                <v-icon
                    v-else
                    x-large
                >
                    mdi-account-outline
                </v-icon>

                <v-expand-transition>
                    <v-card
                        v-if="hover"
                        class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal caption white--text"
                        style="height: 100%;"
                        rounded
                        ripple
                        @click="$refs.userpic.click()"
                    >
                        <v-icon
                            color="white"
                            x-large
                        >
                            mdi-image-plus
                        </v-icon>
                    </v-card>
                </v-expand-transition>
            </v-avatar>
        </v-hover>
        <form
            class="upload-form"
            @submit.prevent=""
        >
            <input
                ref="userpic"
                placeholder="Browse computer"
                type="file"
                @change="uploadAvatar"
            >
        </form>
    </div>
</template>

<script>
    export default {
        data: () => ({
            avatar: null,
        }),
        methods: {
            async uploadAvatar(event) {
                try {
                    const fileSelected = event.target.files.length > 0;

                    if (!fileSelected) {
                        return;
                    }

                    const { data: { url: avatar } } = await Vue.backendApi()
                        .file()
                        .storeFile(event.target.files[0]);

                    this.avatar = avatar;
                    this.$emit('input', avatar);
                } catch (error) {
                    this.$swal({
                        target: document.getElementById('swal2-container'),
                        type: 'error',
                        title: 'We were unable to upload this profile',
                        text: error,
                    });
                }
            },
        },
    };
</script>

<style scoped>

.upload-form {
    visibility: hidden;
    z-index: 0;
    position: fixed;
}

.v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.9;
    position: absolute;
    width: 100%;
}

</style>
